import { styled, Toolbar } from "@mui/material";

export const StyledToolbar = styled(Toolbar)({
  minHeight: "1em !important",
}) as typeof Toolbar;
